import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import ReportingLinkList from 'src/features/siva/reporting/components/ReportingLinkList/ReportingLinkList';
import { getAllYearSince } from 'src/features/siva/utils';
import { ROUTES } from 'src/navigation';

const SivaAdminGoalsPage: React.FC = () => {
  const { t } = useTranslation('siva');
  const years = getAllYearSince();

  return (
    <ContentPage title={t('report.goals')}>
      <ReportingLinkList
        items={years.map((year) => ({
          to: ROUTES.SIVA.ADMIN.GOALS.YEAR(year).BASE,
          title: `${t('report.goals')} ${year}`,
        }))}
      />
    </ContentPage>
  );
};

export default SivaAdminGoalsPage;
